<template>
  <!-- <div class="Newdetail" v-if="index >= 3" v-html="list[index - 3].cont"></div> -->

  <div>
    <Header :navIndex="navIndex"></Header>

    <div style="background: #f2f2f2">
      <div class="location">
        <div class="loca">
          您的位置:
          <span @click="$router.push('/')" style="cursor: pointer">首页</span> >
          <span @click="$router.back(-1)" style="cursor: pointer"
            >阁韵动态</span
          >
          >
          <!-- <span>
            <span v-if="this.type == 1">阁韵新闻</span>
            <span v-else>媒体报道</span>
            >
          </span> -->

          <span style="font-weight: bold">{{ title }} </span>
        </div>
      </div>

      <div class="normal">
        <!-- 一部分 -->
        <div class="cont">
          <div class="norTitle">{{ title }}</div>
          <div class="autho">
            <span class="mr">作者:</span>
            <span class="mr">{{ author }}</span>
            <span class="mr">编辑:</span>
            <span class="mr">{{ editor }}</span>
            <span class="mr">来源:</span>
            <span class="mr">{{ source }}</span>
            <span class="mr">发布日期:</span>
            <span>{{ date }}</span>
          </div>
        </div>
        <div id="content" v-html="content"></div>
      </div>
    </div>
    <div class="bottom">
      <!-- 如果是第一条 就没有上一条 -->
      <div class="prew" @click="last()">
        <div class="last">上一条</div>
        <div class="sub">{{ prevtitle }}</div>
      </div>
      <div class="line"></div>
      <div class="prew" @click="next()">
        <div class="last">下一条</div>
        <div class="sub">{{ nexttitle }}</div>
      </div>
      <div class="back" @click="back">返回</div>
    </div>
    <Part5></Part5>
  </div>
</template>

<script>
import Header from "../components/Header";
import Part5 from "../components/Part5";
import { newsDetail } from "../api/request";

export default {
  components: { Header, Part5 },

  name: "Detail",
  props: {
    number: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    // console.log(this.$route.params);

    this.previd = this.$route.params.previd;
    this.nextid = this.$route.params.nextid;
    this.nexttitle = this.$route.params.nexttitle;
    this.prevtitle = this.$route.params.prevtitle;
    var obj = this.$route.params.item;

    this.title = obj.title;
    this.author = obj.author;
    this.date = this.timestampToTime2(obj.createtime);

    this.editor = obj.editor;
    this.source = obj.source;
    this.content = obj.content;
    // this.type = obj.type;
  },
  data() {
    return {
      nexttitle: "",
      prevtitle: "",
      previd: null,
      nextid: null,
      navIndex: 5,
      // type: "",
      title: "",
      author: "",
      date: "",
      editor: "",
      source: "",
      content: "",
      index: 3,
    };
  },
  methods: {
    last() {
      // 上一个
      newsDetail({ id: this.previd }).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data);
          var obj1 = res.data.data;

          this.nexttitle = obj1.next_title;
          this.prevtitle = obj1.pre_title;
          this.previd = obj1.pre_id;
          this.nextid = obj1.next_id;

          this.title = obj1.title;
          this.author = obj1.author;
          this.date = this.timestampToTime2(obj1.createtime);

          this.editor = obj1.editor;
          this.source = obj1.source;
          this.content = obj1.content;
        }
      });

      this.top();
    },
    next() {
      // 下一个
      newsDetail({ id: this.nextid }).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data);
          var obj1 = res.data.data;

          this.title = obj1.title;
          this.author = obj1.author;
          this.date = this.timestampToTime2(obj1.createtime);

          this.editor = obj1.editor;
          this.source = obj1.source;
          this.content = obj1.content;
          this.nexttitle = obj1.next_title;
          this.prevtitle = obj1.pre_title;
          this.previd = obj1.pre_id;
          this.nextid = obj1.next_id;
        }
      });
      this.top();
    },
    top() {
      // 向上
      cancelAnimationFrame(this.timer);
      const self = this;
      self.timer = requestAnimationFrame(function fn() {
        const oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          self.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(self.timer);
        }
      });
    },
    back() {
      console.log("返回");
      this.$router.push("/Dynamic");
    },
    // 时间戳转年月日时分秒
    timestampToTime2(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          date.getDate() < 10
            ? "0" + date.getDate() + " "
            : date.getDate() + " ";
        var H = date.getHours() + ":";
        var M2 =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var S =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + H + M2 + S;
      }
    },
  },
  watch: {
    // number: {
    //   immediate: true,
    //   handler: function (newVal) {
    //     console.log(newVal);
    //     this.index = newVal;
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped lang="less">
::v-deep img {
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}
// ::v-deep p {
//   margin: 0 auto;
//   text-align: justify;
//   width: 62.344vw;
//   font-size: 1.042vw;
//   font-family: MicrosoftYaHei;
//   font-weight: 400;
//   color: #6c7a77;
//   line-height: 1.875vw;
// }
.Newdetail {
  color: #ccc;
}
.location {
  height: 85px;
  padding-bottom: 20px;
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: flex-end;
  .loca {
    margin-left: 320px;
    font-size: 24px;
    color: #004c31;
  }
}
.normal {
  width: 1280px;
  margin: 31px auto 0;
  background: #ffffff;
  padding-bottom: 52px;
  .cont {
    padding: 46px 39px;
    border-bottom: 1px dotted #ccc;
    .norTitle {
      font-size: 32px;
      font-weight: bold;
      color: #004c31;
      text-align: left;
    }
    .autho {
      text-align: left;
      font-size: 14px;
      color: #6c7a77;
      margin-top: 23px;
    }
  }
  .text {
    padding: 40px;
    text-align: justify;
    width: 1197px;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #6c7a77;
    line-height: 36px;
  }
  .descImg {
    margin: 0 auto;
    width: 800px;
    height: 452px;
    img {
      width: 800px;
      height: 452px;
    }
  }
  .descImg1 {
    margin: 0 auto;
    width: 1080px;
    height: 810px;
    img {
      width: 1080px;
      height: 810px;
    }
  }
}
.mr {
  margin-right: 10px;
}
.bottom {
  width: 1200px;
  margin: 49px auto 0;
  padding-bottom: 100px;
  .prew {
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover .last {
      background: #004c31;
      border-color: #004c31;
      color: #ffffff;
    }
    &:hover .sub {
      color: #004c31;
    }
    .last {
      width: 145px;
      height: 40px;
      border: 1px solid #6c7a77;
      color: #6c7a77;
      font-size: 18px;
      text-align: center;
      line-height: 40px;
    }
    .sub {
      font-size: 20px;
      color: #6c7a77;
      margin-left: 26px;
    }
  }
  .line {
    width: 1200px;
    height: 1px;
    border-bottom: 1px dotted #6c7a77;
    margin: 10px auto;
  }
  .back {
    cursor: pointer;
    width: 145px;
    height: 41px;
    background: #004c31;
    color: #ffffff;
    margin-top: 42px;
    text-align: center;
    line-height: 41px;
    margin-left: 1055px;
  }
}
#content {
  padding: 50px;
  // border: 1px solid blue;
  // width: 98vw;
}

@media screen and (max-width: 450px) {
  ::v-deep img {
    margin: 0 auto;
    max-width: 100%;
    height: auto;
  }
  .location {
    height: 85 * 2px;
    padding-bottom: 20 * 2px;
    width: 100%;
    background: #ffffff;
    display: flex;
    align-items: flex-end;
    .loca {
      text-align: left;
      margin-left: 0px;
      font-size: 24 * 2px;
      color: #004c31;
    }
  }
  .normal {
    width: auto;
    margin: 31px auto 0;
    background: #ffffff;
    padding-bottom: 52px;
    .cont {
      padding: 46px 39px;
      border-bottom: 1px dotted #ccc;
      .norTitle {
        font-size: 32 * 2px;
        font-weight: bold;
        color: #004c31;
        text-align: left;
      }
      .autho {
        text-align: left;
        font-size: 14 * 2px;
        color: #6c7a77;
        margin-top: 23 * 2px;
      }
    }
    .text {
      padding: 40 * 2px;
      text-align: justify;
      width: auto;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #6c7a77;
      line-height: unset;
    }
    .descImg {
      margin: 0 auto;
      width: 800 * 2px;
      height: 452 * 2px;
      img {
        width: 800 * 2px;
        height: 452 * 2px;
      }
    }
  }
  .mr {
    margin-right: 10px;
  }
  .bottom {
    width: auto;
    margin: 49 * 2px auto 0;
    padding-bottom: 100px;
    .prew {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover .last {
        background: #004c31;
        border-color: #004c31;
        color: #ffffff;
      }
      &:hover .sub {
        color: #004c31;
      }
      .last {
        width: 145 * 2px;
        height: 40 * 2px;
        border: 1px solid #6c7a77;
        color: #6c7a77;
        font-size: 18 * 2px;
        text-align: center;
        line-height: 40 * 2px;
      }
      .sub {
        font-size: 20 * 2px;
        color: #6c7a77;
        margin-left: 26 * 2px;
      }
    }
    .line {
      width: 1200px;
      height: 1px;
      border-bottom: 1px dotted #6c7a77;
      margin: 10px auto;
    }
    .back {
      font-size: 32px;
      cursor: pointer;
      width: 145 * 2px;
      height: 41 * 2px;
      background: #004c31;
      color: #ffffff;
      margin-top: 42 * 2px;
      text-align: center;
      line-height: 41 * 2px;
      margin-left: 1055 * 1.2px;
    }
  }

  #content {
    padding: 100px;
    // line-height: 50px;
    // width: 98vw;
  }
}
</style>
